import { ThemeProvider } from '@ori-ui/mui';
import { NOT_LOGGED_IN_USER_ID, UniversalTokenProvider } from '@ori/auth';
import { ErrorBoundary } from '@ori/presentation-components';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { APP_NAME } from './constants';
import type { AppConfiguration } from './models';

/**
 * React app renderer that is used when app is used as a standalone app
 */
export async function render(rootElement: HTMLElement) {
  const { dataset, style } = rootElement;
  const appConfig: AppConfiguration = {
    bannerApiUrl: dataset.bannerApiUrl ?? '',
    bannerSelector: dataset.bannerPortalSelector,
    breadcrumbsApiUrl: dataset.breadcrumbsApiUrl ?? '',
    breadcrumbsSelector: dataset.breadcrumbsPortalSelector,
    contentSelector: dataset.contentPortalSelector,
    customerId: dataset.customerId ? Number(dataset.customerId) : NOT_LOGGED_IN_USER_ID,
    isPortalMode: dataset.mode === 'portal',
    pageId: dataset.pageId ?? '',
    submenuSelector: dataset.submenuPortalSelector,
    staticApiUrl: dataset.staticApiUrl ?? '',
    tenant: dataset.tenant ?? '',
    currentLanguage: dataset.currentLanguage ?? '',
  };

  if (appConfig.isPortalMode) {
    style.display = 'none';
  }
  const { customerId } = appConfig;

  // Get token for local development
  if (
    process.env.NODE_ENV !== 'production' && // when using Requestly we do not want to load token
    process.env.REACT_APP_USE_REQUESTLY === '1'
  ) {
    // eslint-disable-next-line no-console -- Log info about requestly mode.
    console.log('USING REQUESTLY');
  }

  createRoot(rootElement).render(
    <ErrorBoundary>
      <UniversalTokenProvider
        customerId={customerId}
        initialToken=""
      >
        <ThemeProvider
          enableCacheProvider
          cacheKey={APP_NAME}
        >
          <App {...appConfig} />
        </ThemeProvider>
      </UniversalTokenProvider>
    </ErrorBoundary>,
  );
}
